var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3142_14335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8326 26.3332L23.4992 22.9999M23.4992 22.9999L20.1659 26.3332M23.4992 22.9999V30.4999M30.4909 28.3249C31.3037 27.8818 31.9458 27.1806 32.3158 26.3321C32.6858 25.4835 32.7627 24.5359 32.5344 23.6388C32.3061 22.7417 31.7855 21.9462 31.0548 21.3778C30.3241 20.8094 29.425 20.5005 28.4992 20.4999H27.4492C27.197 19.5243 26.7269 18.6185 26.0742 17.8507C25.4215 17.0829 24.6033 16.4731 23.681 16.0671C22.7587 15.661 21.7564 15.4694 20.7493 15.5065C19.7423 15.5436 18.7568 15.8085 17.8669 16.2813C16.977 16.7541 16.2058 17.4225 15.6114 18.2362C15.017 19.05 14.6148 19.9879 14.4351 20.9794C14.2553 21.9709 14.3027 22.9903 14.5736 23.961C14.8445 24.9316 15.3319 25.8281 15.9992 26.5832",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3142_14335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconSvg);
export default __webpack_public_path__ + "static/media/upload_icon_svg.3dde5835e248e1952972330b224d8033.svg";
export { ForwardRef as ReactComponent };